// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"1a70ce46","75":"e2a571c0","345":"e2669f2d","967":"72b58319"}[chunkId] + ".chunk.js";
};